import { createAsyncThunk } from "@reduxjs/toolkit";
import DayLightTimeService from "../services/DayLightTimeService";

export const getDayLightTime = createAsyncThunk(
  "/day-light-times",
  async (payload) => {
    const res = await DayLightTimeService.getDayLightTime(payload);
    return res.data;
  }
);

export const createDayLightTime = createAsyncThunk(
  "/day-light-time",
  async (payload) => {
    const res = await DayLightTimeService.createDayLightTime(payload);
    return res.data;
  }
);

export const deleteDayLightTime = createAsyncThunk(
  "/day-light-time",
  async (id) => {
    const res = await DayLightTimeService.deleteDayLightTime(id);
    return res.data;
  }
);

export const updateDayLightTime = createAsyncThunk(
  "/day-light-time",
  async (payload) => {
    const res = await DayLightTimeService.updateDayLightTime(payload);
    return res.data;
  }
);

export const getDayLightTimeBySiteId = createAsyncThunk(
  "/day-light-time/siteId",
  async (payload) => {
    const res = await DayLightTimeService.getDayLightTimeBySiteId(payload);
    return res.data;
  }
);
